import React, { Component } from "react";

import { Card, CardBody, Col, Container, Row } from "reactstrap";

import "react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css";

//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import RemoteTable from "../../../components/Common/RemoteTable";
import { getBannersVkList, integrationStateInit } from "../../../store/integration/actions";
import ModifiedMetaTags from '../../../components/ModifiedMetaTags/index';

class BannersVk extends Component {
  constructor(props) {
    super(props);

    this.state = {
      page: 1,
      sizePerPage: 10,
      filter_name: [],
    };

    this.searchTimer = null;
  }

  componentDidMount() {
    this.props.getBannersVkList(this.props.data);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
  }

  componentWillUnmount() {
    this.props.integrationStateInit()
  }

  handleTableChange = (data) => {
      this.props.getBannersVkList(data);
  };

  render() {
    const columns = [
      {
        dataField: "id",
        text: "ID",
        sort: true,
      },
      {
        dataField: "campaign_id",
        text: "Campaign ID",
        sort: true,
      },
      {
        dataField: "name",
        text: "Name",
        sort: true
      },
      {
        dataField: "status",
        text: "Status",
        sort: true,
      },
      {
        dataField: "create_time",
        text: "Create time",
        sort: true,
      },
      {
        dataField: "update_time",
        text: "Update time",
        sort: true,
      },
    ];

    return (
      <React.Fragment>
        <div className="page-content">
        <ModifiedMetaTags title="Banners VK | Mobihunter" />

          <Container fluid>
            <Breadcrumbs title="Dashboard" breadcrumbItem="Banners VK" link="/dashboard"/>
            <Row>
              <Col className="col-12">
                <Card>
                  <CardBody>
                    <RemoteTable
                      onTableChange={this.handleTableChange}
                      columns={columns}
                      data={this.props.data}
                      loading={this.props.loading}
                    >
                    </RemoteTable>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

BannersVk.propTypes = {
  data: PropTypes.object,
  loading: PropTypes.bool,
  getBannersVkList: PropTypes.func.isRequired,
  integrationStateInit: PropTypes.func.isRequired,
  permissions: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  data: state.Integration.dataBannerVk,
  loading: state.Integration.loading_banner_vk,
  permissions: state.User.permissions
});

export default connect(mapStateToProps, { getBannersVkList, integrationStateInit })(
  BannersVk
);
